<!-- <app-sidebar></app-sidebar>
<div class="page">
    <app-header></app-header>
  </div>

  <div class="page">
    <app-header></app-header>
    <div class="d-flex">
      <div>
        <app-sidebar></app-sidebar>
      </div>
      <div class="manageContentSize">
          <router-outlet></router-outlet>
      </div>
  </div>
    <footer class="main-footer">
      <div class="container-fluid">
        <div class="row">
          <div class="col-sm-12">
            <span class="text-center">
              &copy;2020. All Right Reserved.
            </span>
            <div class="float-right">

              <app-version></app-version>
            </div>
          </div>
        </div>
      </footer>
</div> -->

<sm-loader></sm-loader>


<ng-container
  *ngIf="ss.underMaintenance && this.tokenDetails.tokenData.role !== 1 && this.tokenDetails.tokenData.role !== 4; else appContent">
  <div class="main-container align-items-center justify-content-center">
    <app-under-maintenance></app-under-maintenance>
  </div>
</ng-container>


<ng-template #appContent>
  <ng-container
    *ngIf="ss.getlocalStorage('token') && !router.url.includes('/login') && !isPublicStandaloneRoute">
    <!-- <ng-container "></ng-container> -->
    <app-sidebar></app-sidebar>
    <div class="page">
      <app-header></app-header>
      <router-outlet></router-outlet>
      <!-- <app-student-intenrship-details></app-student-intenrship-details> -->

      <footer class="main-footer">
        <div class="container-fluid">
          <div class="row">
            <div class="col-sm-12">
              <span class="text-center">
                &copy;{{getCurrentYear()}}. All Right Reserved.
              </span>
              <div class="float-right">
                <app-version></app-version>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  </ng-container>

  <!-- *ngIf="ss.getlocalStorage('token')" -->
  <!-- *ngIf="router.url.includes('/login') || router.url.includes('/otp') || router.url.includes('/forgotpassword') || router.url.includes('/resetpassword') || router.url.includes('/scholarship/apply')" -->
  <ng-container *ngIf="isPublicStandaloneRoute">
    <router-outlet></router-outlet>
  </ng-container>
  <ng-container *ngIf="!ss.getlocalStorage('token') && !isPublicStandaloneRoute">
    <router-outlet></router-outlet>

  </ng-container>
</ng-template>
